'use client';

import { useId } from 'react';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { FAQView, type FAQProps } from './faq-view';

/** Client-only compositions keep locale updates; server routes use faq-server. */
export function FAQ(props: FAQProps) {
  const { t } = useTranslations();
  const disclosureGroup = useId();
  return (
    <FAQView
      {...props}
      disclosureGroup={disclosureGroup}
      labels={{
        title: t('text1088'),
        description: t('text2334'),
        contact: t('text1153'),
      }}
    />
  );
}
